<template>
  <div v-if="config.implemented">
    <b-card>
      <b-card-header>
        <i :class="`${config.icon} mr-1`"></i> {{ config.label }} Configuration
      </b-card-header>
      <b-card-body class="email-marketing-provider">
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="contact-list">Primary Contact List:</label>
            <select id="contact-list" :value="primaryContactList" class="form-control" required @change="handleChange">
              <option value="" disabled="disabled">
                -- Select a Primary Contact List --
              </option>
              <option v-for="list in contactLists" :key="list.id" :value="list.id">
                {{ list.name }}
              </option>
            </select>
          </div>

          <div class="form-group text-right">
            <button type="submit" class="btn btn-primary">Save Configuration</button>
          </div>
        </form>
      </b-card-body>
    </b-card>
    <b-button-toolbar v-if="primaryContactList" key-nav :aria-label="config.label + ' Actions'"
      class="mt-3 align-items-center justify-content-center">
      <b-button-group class="mx-1">
        <b-button @click="syncMembers"><i class="fas fa-sync"></i> Sync Members</b-button>
      </b-button-group>
    </b-button-toolbar>
  </div>
</template>

<script>
import PROVIDER_CONFIG from "../provider-configs";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EmailMarketingProvider",
  props: {
    provider: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      config: {},
    };
  },
  computed: {
    ...mapGetters(["contactLists", "primaryContactList"]),
  },
  mounted() {
    this.loadConfig();
    console.log("Provider:", this.provider, "Config:", this.config);
    if (this.provider/*  && this.config.createdAt */) {
      this.fetchContactLists();
    }
  },
  methods: {
    ...mapActions(["getContactLists", "putPrimaryContactList", "syncEmailMarketingMembers"]),
    loadConfig() {
      // Find the provider configuration based on the provider name
      const config = PROVIDER_CONFIG.find((p) => p.service === this.provider);
      this.config = config || {};
    },
    async fetchContactLists() {
      console.log("Fetching contact lists for provider:", this.provider);
      try {
        this.getContactLists({ service: this.provider });
        this.config.primaryContactList = this.primaryContactList;
      } catch (error) {
        console.error("Error fetching contact lists:", error);
      }
    },
    handleChange(event) {
      this.config.primaryContactList = event.target.value;
    },
    async handleSubmit() {
      try {
        await this.putPrimaryContactList({
          service: this.provider,
          listId: this.config.primaryContactList,
        });
        console.log("Configuration saved successfully");
      } catch (error) {
        console.error("Error saving configuration:", error);
      }
    },
    async syncMembers() {
      try {
        const resp = await this.syncEmailMarketingMembers({ service: this.provider });
        console.log("Member sync initiated successfully");
        // present successful toast message to user
        this.$bvToast.toast('Member sync initiated ' + resp.queuedMembers + ' contacts successfully', {
            title: 'Success',
            variant: 'success',
            solid: true
          });
      } catch (error) {
        console.error("Error initiating member sync:", error);
      }
    },
  },
};
</script>

<style scoped>
.email-marketing-provider {
  padding: 20px;
}
</style>
